module.exports = __webpack_public_path__ + "static/media/SEO-wins.597a2182.png";